<template>
  <div>
    <!-- <v-main> -->
    <v-container class="fill-height pa-3">

      <!-- 初回アクセス時のみ表示する注意モーダル -->
      <v-dialog v-model="showResearchNotice" max-width="520" persistent>
        <v-card>
          <v-card-title class="text-h6">
            {{ $t('home.research_notice_title') }}
          </v-card-title>

          <v-card-text style="line-height: 1.8;">
            {{ $t('home.research_notice_body') }}
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn color="primary" rounded @click="closeResearchNotice">
              {{ $t('home.research_notice_button') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-menu bottom :close-on-click="closeOnClick" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on" small rounded outlined>
            <v-icon small>mdi-translate</v-icon>{{ $t('home.language') }}<v-icon small>mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, index) in items" :key="index" @click="setLocale(item.code)">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-row justify="center" align-content="center">
        <div>
          <v-col cols="12" class="d-flex flex-column align-center">
            <h3 class="mt-8 text-center">{{ $t('home.title') }}</h3>

            <v-img class="my-6 mx-auto" width="80"
              src="https://soco-st.com/wp-content/themes/socost/upload/16457_color.svg" />
          </v-col>

          <v-row justify="center" class="mt-2">
            <!-- ログインしてないとき -->
            <section v-if="this.$store.state.user.name === 'guest'">
              <v-row justify="center" class="my-2">
                <v-btn large rounded color="primary" width="150" @click="login()"><img :src="googleLogo"
                    alt="Google G Logo" width="26" height="26" />{{ $t('home.login') }}</v-btn>
              </v-row>
              <v-row justify="center" class="my-5">
                <v-btn large rounded color="gray" @click="toDrawGuest()" width="150">{{ $t('home.draw_as_guest')
                  }}</v-btn>
              </v-row>
              <v-row justify="center">
                <p style="font-size: 12px; text-align: center; color: gray;">{{ $t('home.album_hint') }}</p>
              </v-row>
              <v-row justify="center" class="mt-8">
                <a href="https://forms.gle/vbCjaxhDxkfMv5WF9" style="font-size: 12px; color: blue;" target="_blank">{{
                  $t('home.survey') }}</a>
              </v-row>
            </section>
            <!-- ログインしてるとき -->
            <section v-else>
              <v-row justify="center" class="my-2">
                <v-btn large rounded color="primary" @click="toDraw()" width="150">{{ $t('home.draw') }}</v-btn>
              </v-row>
              <v-row justify="center" class="my-2">
                <v-btn large rounded color="primary" @click="toCollection()" width="150">{{ $t('home.album')
                  }}</v-btn>
              </v-row>
              <v-row justify="center" class="my-5">
                <v-btn large rounded color="gray" @click="logout()" width="150">{{ $t('home.logout') }}</v-btn>
              </v-row>
              <v-row justify="center" class="mt-8">
                <a href="https://forms.gle/vbCjaxhDxkfMv5WF9" @click.prevent="openSurvey"
                  style="font-size: 12px; color: blue;" target="_blank">{{
                    $t('home.survey') }}</a>
              </v-row>
            </section>
          </v-row>
        </div>
      </v-row>
    </v-container>
    <!-- </v-main> -->

  </div>
</template>

<script>
// import firebase from "firebase";// これを追加！
// 以下の関数内で使いたいメソッドを firebaseのauthクラスから呼び出しておく
import { getAuth, signInWithPopup, GoogleAuthProvider, } from "firebase/auth";
import googleLogo from '@/assets/google_icon.svg';
import { fire, fireSessionEnd, getPrevScreen, setCurrentScreen } from '@/utils/logger';


export default {
  props: ['aquarium'], // ルーターから受け取るプロップス
  data() {
    return {
      googleLogo,
      items: [
        { title: '🇯🇵 日本語', code: 'ja' },
        { title: '🇺🇸 English', code: 'en' },
        { title: '🇨🇳 中文', code: 'zh' },
        { title: '🇰🇷 한국어', code: 'ko' },
      ],
      closeOnClick: true,
      language: 0,
      showResearchNotice: false,
    };
  },
  mounted() {
    this.$returnScroll();
    this._homeViewId = crypto.randomUUID();
    this._homeStart = performance.now();
    this._activeStart = performance.now();
    this._activeTotal = 0;
    this.checkResearchNotice();

    // // --- セッション開始（初回だけ）にログを送信 ---
    // const sid = sessionStorage.getItem('session_id'); // fire()前でも既に生成済み
    // const key = `session_started_for:${sid}`;
    // if (!sessionStorage.getItem(key)) {
    //   fire('session_start', {
    //     device_id: deviceId,
    //     app_version: process.env.VUE_APP_VERSION || 'dev',
    //     locale: this.$i18n.locale,
    //     aquarium: this.aquarium,
    //     uid: this.$store.state.user?.uid || null,
    //     // uid_auth: this.$store.state.user?.uid_auth || null,
    //     referer: document.referrer || null,
    //   });
    //   sessionStorage.setItem(key, '1');
    //   markSessionStart(); //開始時刻を記録
    // }

    // 初回アクセス時のみ注意モーダルを表示
    // const noticeKey = `research_notice_shown_${this.aquarium}`;
    const noticeKey = `research_notice_shown_${this.aquarium}_${this.$i18n.locale}`;
    if (!localStorage.getItem(noticeKey)) {
      this.showResearchNotice = true;
    }

    // --- page_view(home) ホーム画面開いたログ ---
    const from = getPrevScreen();   // ← 直前の画面名
    const screen = 'home';          // この画面名
    this._homeViewId = crypto.randomUUID();
    this._homeStart = performance.now();
    fire('page_view', {
      view_id: this._homeViewId,
      screen,
      from,
      locale: this.$i18n.locale,
      aquarium: this.aquarium,
    });
    // 送ったあと「現在の画面」を記録（次のページの from になる）
    setCurrentScreen(screen);

    // 離脱時（ページを閉じるときやタブが非表示になったとき）に page_leave を1回
    document.addEventListener('visibilitychange', this._onVisibilityChange);
    window.addEventListener('beforeunload', () => {
      fireSessionEnd('close');
    }, { once: true });
  },
  beforeDestroy() {
    this._flushHomeLeave();
    document.removeEventListener('visibilitychange', this._onVisibilityChange);
  },
  created() {
    this.$store.state.aquarium = this.aquarium;

    // base.json と現在ロケールの辞書をロードし、penguins を作る(ensureAquariumLoadedはloadPenguinLocale、loadPenguinBaseを含む)
    this.$store.dispatch('ensureAquariumLoaded', this.aquarium);

    // 言語が変わったら辞書だけ取り直して再マージ（図鑑などが即時反映）
    this.$watch(() => this.$i18n.locale, async (loc) => {
      await this.$store.dispatch('loadPenguinLocale', loc);
      await this.$store.dispatch('rebuildPenguins');
    });

    // （必要なら）日本語逆引きも起動時に作成
    this.$store.dispatch('buildJaReverseMap');
  },
  methods: {
    checkResearchNotice() {
      const noticeKey = `research_notice_shown_${this.aquarium}_${this.$i18n.locale}`;
      this.showResearchNotice = !localStorage.getItem(noticeKey);
    },

    closeResearchNotice() {
      const noticeKey = `research_notice_shown_${this.aquarium}_${this.$i18n.locale}`;
      localStorage.setItem(noticeKey, 'true');
      this.showResearchNotice = false;

      fire('research_notice_accepted', {
        screen: 'home',
        aquarium: this.aquarium,
        locale: this.$i18n.locale,
      });
    },
    setLocale(code) { // 言語設定を変更するメソッド
      const from = this.$i18n.locale;
      this.$i18n.locale = code;            // 即時に切り替わる
      localStorage.setItem('locale', code); // リロードやページ移動しても保持
      fire('lang_change', { from, to: code, screen: 'home' })// ユーザが言語を切り替えたときのログ
      this.checkResearchNotice(); // 言語切り替えのたびに注意モーダルの表示要否を再チェック
    },
    toDraw() {
      fire('cta_click', { button: 'draw', mode: 'logged_in' }); // ログイン状態でお絵かきボタンを押したときのログ
      this.$router.push(`/${this.aquarium}/draw-penguin`);
    },
    toCollection() {
      fire('cta_click', { button: 'album' }); // 図鑑ボタンを押したときのログ
      this.$router.push(`/${this.aquarium}/collection`);
    },
    toDrawGuest() {
      this.$store.state.user = {
        name: "guest",
        mail: "guest"
      };
      fire('cta_click', { button: 'draw', mode: 'guest' }); // ゲスト状態でお絵かきボタンを押したときのログ
      this.$router.push(`/${this.aquarium}/draw-penguin`);
    },
    login() {
      fire('login_click', { provider: 'google' }); // ログインボタンを押したときのログ
      const provider = new GoogleAuthProvider();
      const auth = getAuth();
      signInWithPopup(auth, provider)
        // .then(async cred => {
        //   fire('login_result', {
        //     provider: 'google',
        //     ok: true,
        //     uid: cred.user?.uid || null,
        //     // uid_auth: (await cred.user?.getIdToken?.()) || null
        //   });
        // })
        .catch(err => {
          fire('login_result', { provider: 'google', ok: false });
          fire('error_client', { code: 'login_error', message: String(err), screen: 'home' });
        });
    },
    logout() {
      fire('logout_click', { provider: 'google' }); // ログアウトボタンを押したときのログ
      const auth = getAuth();
      auth.signOut().then(() => {
        fireSessionEnd('logout'); // ← ここで dwell_ms が入る
        sessionStorage.removeItem('sent_login_result');
        sessionStorage.clear(); // 新しいタブ同等の状態に
      })
        .catch(err => {
          fire('error_client', { code: 'logout_error', message: String(err), screen: 'home' });
        });
    },

    _onVisibilityChange() {
      const now = performance.now();
      if (document.visibilityState === 'hidden') {
        // 非表示になる → ここまでのアクティブ時間を合計に加算
        this._activeTotal += now - this._activeStart;
      } else if (document.visibilityState === 'visible') {
        // 表示に戻った → 再開地点を更新
        this._activeStart = now;
      }
    },

    // 「ホーム画面にどれくらい滞在したか」を送る
    _flushHomeLeave() {
      if (!this._homeStart || this._homeLeft) return;
      this._homeLeft = true;

      const now = performance.now();
      const total = now - this._homeStart;

      // 最後に visible のまま終わった場合、残りも加算
      if (document.visibilityState === 'visible') {
        this._activeTotal += now - this._activeStart;
      }

      fire('page_leave', {
        view_id: this._homeViewId,
        screen: 'home',
        total_ms: Math.round(total),
        active_ms: Math.round(this._activeTotal)
      });
    },
    openSurvey() {
      const url = "https://forms.gle/vbCjaxhDxkfMv5WF9";

      fire('cta_click', {
        button: 'survey',
        target: 'google_form_url'
      });

      // ログ送ったあとにリンクを開く
      window.open(url, '_blank');
    },
  },
};
</script>

<style>
div {
  touch-action: auto;
}
</style>